/*! *********************************************************************
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { useState } from 'react';
import { Create, SimpleForm, FileInput, SelectInput } from 'react-admin';
import _map from 'lodash/map';

import FileField from '../../components/FileField';
import { ASSET_TYPE, ASSET_TYPE_LABEL } from '../../models/asset';

export default (props) => {
  const [assetType, setAssetType] = useState();

  function handleSelectChange(event) {
    setAssetType(event.target.value);
  }

  function getAssetType() {
    return _map(ASSET_TYPE, (assetType) => {
      return {
        id: assetType,
        name: ASSET_TYPE_LABEL[assetType],
      };
    });
  }

  let fileInputProps;
  if (assetType && assetType === ASSET_TYPE.MODEL)
    fileInputProps = {
      label: 'FBX or GLB',
      placeholder: <p>Drop your FBX or GLB file here</p>,
      accept: '.fbx,.glb',
    };
  else if (assetType && assetType === ASSET_TYPE.SUBSTANCE_MODEL)
    fileInputProps = {
      label: 'SBSM',
      placeholder: <p>Drop your SBSM file here</p>,
      accept: '.sbsm',
    };
  else
    fileInputProps = {
      label: 'SBSAR',
      placeholder: <p>Drop your SBSAR file here</p>,
      accept: '.sbsar',
    };

  return (
    <Create title="Asset creation" {...props}>
      <SimpleForm>
        <SelectInput
          source="type"
          choices={getAssetType()}
          onChange={handleSelectChange}
          optionValue="id"
        />

        {fileInputProps && (
          <FileInput source="assetFile" {...fileInputProps}>
            <FileField source="url" title="title" target="_blank" />
          </FileInput>
        )}
      </SimpleForm>
    </Create>
  );
};
